import CREATE_COMPONENT_DATABASE_MUTATION from '@/graphql/mutations/createComponentDatabase.gql';
import COMPONENT_DATABASES_QUERY from '@/graphql/queries/componentDatabases.gql';
import Btn from '@/components/Btn/Btn.vue';
import eventHub from '@/utils/eventHub';

export default {
  name: 'AddDatabase',
  components: { Btn },
  data: () => ({
    CREATE_COMPONENT_DATABASE_MUTATION,
    database: { name: '' },
    nameRules: [v => !!v || 'Name is Required'],
  }),
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    onSubmit(mutate) {
      if (this.validate()) {
        this.$nextTick(() => {
          mutate();
        });
      }
    },
    updateComponentDatabases(store, { data: { createComponentDatabase } }) {
      if (createComponentDatabase) {
        const data = store.readQuery({ query: COMPONENT_DATABASES_QUERY });
        data.componentDatabases.push(createComponentDatabase);
        store.writeQuery({ query: COMPONENT_DATABASES_QUERY, data });
        eventHub.$emit('show-snackbar', {
          color: 'success',
          text: `Database ${this.database.name} was added successfully!`,
        });
      } else {
        eventHub.$emit('show-snackbar', {
          color: 'error',
          text: `Error! Something went wrong... Please try later!`,
        });
      }
    },
  },
};
